import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { restoreVehiclesSuccessful, restoreVehiclesFailed } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* restoreVehicle(action) {
  try {
    const url = `${BACKEND_URL}/registries/vehicles/${action.payload}/restore`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(restoreVehiclesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(restoreVehiclesFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(restoreVehiclesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
